import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List } from 'immutable';

import Button from '../../helpers/Button';
import DropDown, { DropDownElement } from '../../helpers/DropDown';

/**
 * Stateless component for top menu of grid.
 *
 * @param props {Object}.
 * @param props.actionConfigs {Immutable.List} List of available actionList for each event.
 * @param props.selected {Immutable.List} List of selected next actions.
 * @param props.disabled {Boolean} If true, disable drop down list.
 * @param props.onSelectAll {Function} To select all next Actions.
 * @param props.onDeselectAll {Function} To deselect all next actions.
 */
const TopMenuComponent = ({ actionConfigs, onSelectAll, selected, disabled, onDeselectAll, onChange }) => {
  const selectedText = selected.size > 0 ? `${selected.size} selected` : null;
  const actionContents = actionConfigs.map(action => (
    <DropDownElement
      key={action.get('key')}
      isDanger={action.getIn(['attributes', 'isDanger'], false)}
      value={action.get('key')}
    >
      {action.get('name')}
    </DropDownElement>
  ));

  return (
    <>
      <Button onClick={onSelectAll}>
        Select all
      </Button>
      <Button onClick={onDeselectAll}>
        Select none
      </Button>
      <DropDown
        buttonContent="Actions"
        className="btn-default btn-xs"
        disabled={disabled}
        id="actionDropDown"
        name="actionddl"
        onChange={event => onChange(event, { key: event.target.value, selected })}
      >
        {actionContents}
      </DropDown>
      {selectedText && <span className="text-muted ml8">{selectedText}</span>}
    </>
  );
};

TopMenuComponent.propTypes = {
  actionConfigs: PropTypes.instanceOf(List).isRequired,
  disabled: PropTypes.bool.isRequired,
  onDeselectAll: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  selected: PropTypes.instanceOf(List).isRequired,
};

export const TopMenu = memo(TopMenuComponent);
